import dayjs from "dayjs";

export const isRegistrationOpenToday = (calendar: ContestsEditionCalendar) => {
  const now = dayjs();

  // Check if registration dates are defined
  if (!calendar?.registrationStartsAt || !calendar?.registrationEndsAt) {
    return false;
  }

  const registrationStart = dayjs(calendar?.registrationStartsAt);
  const registrationEnd = dayjs(calendar?.registrationEndsAt);

  // Check if today is within the registration period
  return (
    now.isAfter(registrationStart.startOf("day")) &&
    now.isBefore(registrationEnd.endOf("day"))
  );
};
